import { cn } from "@dalmatech/ui"

const root = (className?: string) => cn("shrink-0 gap-1 lg:gap-24 flex items-center", className)

const progressBarTop = cn("flex items-center w-full bg-white px-12")
const completedStepsBarTop = cn("h-[2px] bg-gradient-to-r from-blurple-500 to-blurple-900")
const uncompletedStepsBarTop = cn("h-[2px] bg-neutral-100 w-full flex-1")
const activeStepTop = cn("bg-neutral-25 w-3 h-3 rounded-full flex items-center justify-center")
const activeStepIndicatorTop = cn("bg-black w-[6px] h-[6px] rounded-full")
const progressBarContainerTop = cn("flex flex-col gap-1 items-center bg-white ")

export {
  activeStepIndicatorTop,
  activeStepTop,
  completedStepsBarTop,
  progressBarContainerTop,
  progressBarTop,
  root,
  uncompletedStepsBarTop,
}
